import AemoSettlementConfig from "../js/components/coreServices/AemoSettlementConfig.react";
export default AemoSettlementConfig;
